import * as React from "react";
import "./Spinner1.css";

export default function Spinner() {
  return <span className="loader"></span>;
}